import React from 'react';
import Button from '@ui-library/button';
import {
  ButtonWrapper,
  EditColumnWrapper,
} from '@components/sources/source/warehouseSource/configureData/tableMapping/tableView/style';
import Svg from '@svg/index';
import { cloneDeep } from 'lodash';
import { FixMe } from '@utils/types';
import AddNewColumnInput from './dynamicInputComponent';
import classes from './dynamicInput.module.scss';

interface DynamicInputProps<ValueType> {
  values?: ValueType[];
  onChange?: (values: ValueType[]) => void;
  renderValue?: (value: ValueType) => FixMe;
  validateInput?: (value: FixMe) => string | null;
  inputComponent?: FixMe;
  editMode?: boolean;
}
const DynamicInput = ({
  values = [],
  onChange,
  renderValue = (v) => v,
  validateInput = () => null,
  inputComponent,
  editMode,
}: DynamicInputProps<FixMe>) => {
  const [newValues, setNewValues] = React.useState(values);
  const [enabledInput, setEnabledInput] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (onChange) {
      onChange(newValues);
    }
  }, [newValues]);

  const onAdd = React.useCallback(
    (v) => {
      let errorMessage: string | null = null;
      if (!v) {
        setEnabledInput(false);
        return;
      }
      errorMessage = validateInput(v);

      if (!errorMessage) {
        setNewValues(cloneDeep([...newValues, v]));
        setEnabledInput(false);
      } else {
        setError(errorMessage);
      }
    },
    [newValues, validateInput],
  );

  const onDelete = React.useCallback(
    (index: number) => {
      setNewValues(newValues.filter((_, i) => i !== index));
    },
    [newValues],
  );

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        {newValues.map((value, i) => (
          <EditColumnWrapper editMode={editMode} data-testid="column" key={i}>
            <div className={classes.value}>{renderValue(value)}</div>
            <ButtonWrapper>
              <div
                onClick={() => onDelete(i)}
                className={classes.wrapper}
                role="button"
                tabIndex={0}
              >
                <Svg className="editIcon" name="delete" size={12} />
              </div>
            </ButtonWrapper>
          </EditColumnWrapper>
        ))}
      </div>
      {enabledInput && (
        <AddNewColumnInput
          inputComponent={inputComponent}
          error={error}
          onAdd={onAdd}
          onErrorVisibleChange={() => setError(null)}
          datat-testid="addNewColumnInput"
        />
      )}
      <Button
        onClick={() => {
          setEnabledInput(!enabledInput);
        }}
        className={classes.button}
        data-testid="addButton"
        name="+ Add"
      />
    </div>
  );
};

export default DynamicInput;
